export enum ChartTimeRange{
    UNKNOWN, 
    DAY,
    WEEK, 
    MONTH,
    QUARTER
}